import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/solid/upload-fill.svg'
import _imports_1 from '@/assets/icons/solid/print-fill.svg'
import _imports_2 from '@/assets/icons/solid/document-fill.svg'


const _withScopeId = n => (_pushScopeId("data-v-1840bb08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal justify-center flex text-center items-center"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 right-0 w-screen h-screen flex justify-center items-center pt-16 font-bold font-gotham text-brand-500"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "flex justify-between items-center pb-3 mb-8 border-b-2 border-brand-400" }
const _hoisted_7 = { class: "block md:flex justify-between items-center w-full gap-4" }
const _hoisted_8 = { class: "h-6 rounded-full bg-gray-300 animate-pulse w-1/2 mb-8" }
const _hoisted_9 = { class: "block md:flex gap-x-6 pb-3 md:pb-0 space-y-3 md:space-y-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-6 w-6",
  src: _imports_0,
  alt: "printer icon"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-6 w-6",
  src: _imports_1,
  alt: "printer icon"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-6 w-6",
  src: _imports_1,
  alt: "printer icon"
}, null, -1))
const _hoisted_13 = { class: "grid grid-cols-2 gap-4 lg:gap-6" }
const _hoisted_14 = {
  key: 0,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_15 = {
  key: 1,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_16 = {
  key: 2,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_17 = {
  key: 3,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_18 = {
  key: 4,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_19 = { class: "col-span-2" }
const _hoisted_20 = {
  key: 6,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_21 = { class: "w-full px-4" }
const _hoisted_22 = {
  key: 7,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_23 = {
  key: 8,
  class: "col-span-2"
}
const _hoisted_24 = {
  key: 9,
  class: /*#__PURE__*/_normalizeClass(['col-span-2'])
}
const _hoisted_25 = {
  key: 10,
  class: "col-span-2"
}
const _hoisted_26 = { class: "col-span-2" }
const _hoisted_27 = {
  key: 11,
  class: "col-span-2"
}
const _hoisted_28 = {
  key: 12,
  class: "col-span-2"
}
const _hoisted_29 = { class: "col-span-2" }
const _hoisted_30 = {
  class: "col-span-2",
  id: "scenes"
}
const _hoisted_31 = { class: "col-span-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" }
const _hoisted_32 = { class: "col-span-2" }
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = {
  key: 0,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 0,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon w-16 m-auto",
  src: _imports_2,
  alt: "document icon"
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "text-gray-900 font-medium mt-2" }
const _hoisted_42 = { class: "text-sm" }
const _hoisted_43 = { class: "text-sm" }
const _hoisted_44 = {
  key: 1,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6"
}
const _hoisted_45 = ["href"]
const _hoisted_46 = {
  key: 0,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 1,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon w-16 m-auto",
  src: _imports_2,
  alt: "document icon"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "text-gray-900 font-medium mt-2" }
const _hoisted_52 = { class: "text-sm" }
const _hoisted_53 = { class: "text-sm" }
const _hoisted_54 = ["href"]
const _hoisted_55 = {
  key: 0,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 1,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-48 m-auto text-brand-500 rounded-md"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon w-16 m-auto",
  src: _imports_2,
  alt: "document icon"
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "text-gray-900 font-medium mt-2" }
const _hoisted_61 = { class: "text-gray-500" }
const _hoisted_62 = { class: "text-sm" }
const _hoisted_63 = {
  key: 13,
  class: "col-span-2"
}
const _hoisted_64 = {
  key: 14,
  class: "col-span-2"
}

import { // api
		Auth
	} from '@/api/Auth'

	import JSZip, {
		folder
	} from 'jszip'

	import { 
		getJobByRecordId,
		getJobPrintInstructions,
		getServiceSequenceOrderReport
	} from '../queries'

	import JobDetailsLocation from './DetailsLocation.vue' 	// components
	import JobCovidRestrictions from './CovidRestrictions.vue'
	import JobAdditionalDetails from './AdditionalDetails.vue'
	import JobDiscounts from './Discounts.vue'
	import JobIntroductions from './Introductions.vue'
	import JobItems from './Items.vue'
	import JobRoles from './Roles.vue'
	import JobOptions from './Options.vue'
	import JobVariations from './Variations.vue'
	import JobParticipants from './Participants.vue'
	import JobBorrowedItems from './BorrowedItems.vue'
	import JobTransportationDetails from './TransportationDetails.vue'
	import JobMeetingPlaces from './MeetingPlaces.vue'
	import JobLocations from './Locations.vue'
	import SceneCard from './SceneCard.vue'
	import Meeting from './Meeting.vue'
	import Job from './Job.vue'
	import SceneEditor from './modals/sceneEditor/SceneEditor.vue'

	import EventBus from '@/events' // events

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // router
		useRouter
	} from 'vue-router'

	import { // stores
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'
	import {
		useSceneEditorStore
	} from '@/store/sceneEditor'

	import { // types
		Notification
	} from '@/types'

	import { 
		FileMakerRecord
	} from '@/types'

	import { // vue
		computed,
		inject,
		onBeforeUnmount,
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'JobDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		recordId: {
			type: String,
			default: ''
		} 
	},
  setup(__props) {

	const router = useRouter()

	const _localesStore = localesStore()
	const userStore = _userStore()
	const sceneEditorStore = useSceneEditorStore()

	const {t} = useI18n()

	const props = __props

	const breadcrumb = computed(() => {
		return [
			{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}},
			{label: job.value?.fieldData?.name_bride_groom_display, to: {}},
		]
	})

	const loading = ref(false)

	const job = ref<FileMakerRecord>({} as FileMakerRecord)

	const query = computed(() => {
		const contactId = userStore.user.contactId
		const isStaff = userStore.getContactType === 'Staff'
		const contactIdField = isStaff ? 'job__JOBS_ROLES__jobID::_kf_contacts_id' : '_kf_contacts_id'

		const querySearch = [
			{
				[contactIdField]: contactId,
				recordId: props.recordId
			}
		]

		return querySearch
	})

	onMounted(async () => {
		getData()

		EventBus.on('change-language', async () => {
			await getData(true)
		})
	})

	onBeforeUnmount(() => {
		EventBus.off('change-language', null)
	})
	
	const s3: any = inject('s3')
	async function getData(reset: boolean = false) {
		try {
			loading.value = true

			const contactId = userStore.user.contactId
			const sessionId = userStore.user.sessionId
			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				sessionId,
				contactId
			})

			let params = {
				query: query.value,
				limit: 1,
				"script.prerequest": "Set Language",
				"script.prerequest.param": scriptParams,
				"limit.portal_service_scenes": 100
			}

			// fetch job by record id
			let res = await getJobByRecordId(params)
			const record = res.response.data[0]
			job.value = record

			// get documents from S3
			if(isClient.value) {
				job.value.portalData.portal_documents_client.forEach((doc: any) => {
					const s3Json = JSON.parse(doc?.['job__DOCUMENTS__jobID::s3JSONDocument'] || "{}")
					const key = s3Json?.s3FilePathShortRaw
					const ext = s3Json?.fileExt
					doc.ext = ext
					if(key) {
						let params = {
							Bucket: process.env.VUE_APP_S3_BUCKET,
							Key: key,
							ResponseContentDisposition: `attachment;`
						}

						s3.getSignedUrlPromise('getObject', params).then(
							function (url: string) {
								doc.signedUrl = url
							}, 
							function (err: Error) { 
								throw err
							}
						)
					}
				})
			}
			else {
				// Job documents
				job.value.portalData.portal_documents_staff.forEach((doc: any) => {
					const s3Json = JSON.parse(doc?.['job__DOCUMENTS__jobID::s3JSONDocument'] || "{}")
					const key = s3Json?.s3FilePathShortRaw
					const ext = s3Json?.fileExt
					doc.ext = ext
					if(key) {
						let params = {
							Bucket: process.env.VUE_APP_S3_BUCKET,
							Key: key,
							ResponseContentDisposition: `attachment;`
						}

						s3.getSignedUrlPromise('getObject', params).then(
							function (url: string) {
								doc.signedUrl = url
							}, 
							function (err: Error) { 
								throw err
							}
						)
					}
				})
				// Role documents
				job.value.portalData.portal_documents_staff_role.forEach((doc: any) => {
					const s3Json = JSON.parse(doc?.['job__DOCUMENTS__gContactID::s3JSONDocument'] || "{}")
					const key = s3Json?.s3FilePathShortRaw
					const ext = s3Json?.fileExt
					doc.ext = ext
					if(key) {
						let params = {
							Bucket: process.env.VUE_APP_S3_BUCKET,
							Key: key,
							ResponseContentDisposition: `attachment;`
						}

						s3.getSignedUrlPromise('getObject', params).then(
							function (url: string) {
								doc.signedUrl = url
							}, 
							function (err: Error) { 
								throw err
							}
						)
					}
				})
			}
			

			// Update store
			sceneEditorStore.sceneEditor.availableScenes = [...job.value.portalData.portal_service_scenes]
			sceneEditorStore.sceneEditor.scenes = [...job.value.portalData.portal_main_scenes]
			sceneEditorStore.sceneEditor.jobId = job.value.fieldData['_kp_jobs_id']
		}
		catch(e: any) {
			console.error(e)

			// redirect if server session expired 
			if(e?.code == "952") {
				await Auth.signOut()
				router.push({name: "Login"})
			}
		}
		finally {
			loading.value = false
		}
	}
	
	const printLoading = ref(false)
	
	const signedInStaffRole = computed(() => {
		if(userStore.getContactType === 'Staff') {
			const musicianRole = job.value.portalData.portal_musician_role_staff.filter((role: any) => {
				return role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::_kf_contacts_id'] === userStore.user.contactId
			})
			const liveRole = job.value.portalData.portal_live_role_staff.filter((role: any) => {
				return role?.['job__JOBS_ROLES__liveJobID_gStaffID::_kf_contacts_id'] === userStore.user.contactId
			})
			const standardRole = job.value.portalData.portal_standard_roles_staff.filter((role: any) => {
				return role?.['job__JOBS_ROLES__standardJobID_gStaffID::_kf_contacts_id'] === userStore.user.contactId
			})
			const roleName = [...musicianRole, ...liveRole, ...standardRole][0]['job__job_role__ROLES__roleID_instrumental_gStaffID::name_popup_instructions_join'].split("\r")[0]
			return roleName
		}
		else {
			return null
		}
	})

	async function printInstructions() {
		if(loading.value) return
		try {
			printLoading.value = true
			const contactId = userStore.user.contactId
			const sessionId = userStore.user.sessionId
			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				sessionId,
				contactId,
				jobId: job.value.fieldData._kp_jobs_id,
				role: signedInStaffRole.value
			})

			let res = await getJobPrintInstructions(scriptParams)
			const pdfBase64 = JSON.parse(res.response.scriptResult).results.file

			const linkSource = `data:application/pdf;base64,${pdfBase64}`
			const downloadLink = document.createElement("a")
			const fileName = JSON.parse(res.response.scriptResult).results.fileName

			downloadLink.href = linkSource
			downloadLink.download = fileName
			downloadLink.click()

		}
		catch(e) {
			console.error(e)
		}
		finally {
			printLoading.value = false
		}
	}

	const printingReport = ref(false)

	async function printServiceSequenceOrderReport() {
		if(loading.value) return
		try {
			printLoading.value = true
			printingReport.value = true
			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				jobId: job.value.fieldData._kp_jobs_id
			})

			let res = await getServiceSequenceOrderReport(scriptParams)
			const pdfBase64 = JSON.parse(res.response.scriptResult).file

			const linkSource = `data:application/pdf;base64,${pdfBase64}`
			const downloadLink = document.createElement("a")
			const fileName = JSON.parse(res.response.scriptResult).fileName

			downloadLink.href = linkSource
			downloadLink.download = fileName
			downloadLink.click()

		}
		catch(e) {
			console.error(e)
		}
		finally {
			printLoading.value = false
			printingReport.value = false
		}
	}

	const exportingSongs = ref(false)
	const fetchS3File: any = inject('fetchS3File')

	async function exportSceneSongs() {
		if(loading.value) return
		try {
			printLoading.value = true
			exportingSongs.value = true

			// Create download folder
			const zip = new JSZip()
			const jobDate = job.value.fieldData.zctStartDateFormatted
			const jobId = job.value.fieldData['_kp_jobs_id']
			const brideGroomName = job.value.fieldData.name_bride_groom_display
			const jobTime = job.value.fieldData.zctStartTimeFormatted
			const room = job.value.fieldData['job__ROOMS__roomID::name_full_display']
			const folderName = `${jobDate}-ID${jobId}-${brideGroomName}-${jobTime}-${room}`
			const downloadFolder = zip.folder(folderName)

			// Export all main scene songs
			await Promise.all(job.value?.portalData?.portal_main_scenes?.map(async (record: any) => {
				const songId = record['job__JOBS_SCENES__jobID::zctSongID']

				if(songId?.length) {
					// Ensure 2 digit scene number
					const sceneNumber = String(record['job__JOBS_SCENES__jobID::scene_number']).padStart(2, '0')
					const sceneName = record['job__job_scene__SCENES__sceneID::name_display']
					const songName = record['jobs__jobs_scenes__SONGS__songID::name_display']
					const songFileJSON = record['jobs__jobs_scenes__SONGS_INFO__songID::s3JSONSong']
					const fileExtension = JSON.parse(songFileJSON).fileExt
					const fileName = `${sceneNumber} ${sceneName} - ${songName}.${fileExtension}`

					// Get song from s3 and add to download folder
					const signedUrl = await fetchS3File(songFileJSON)
					const song = await fetch(signedUrl).then(r => r.blob())
					downloadFolder?.file(fileName, song)
				}
			}))
			
			// Will count the folder name as a key
			const fileLength = Object.keys(downloadFolder?.files || '{}').length - 1
			
			if(fileLength > 0) {
				// Generate zip and trigger download
				await zip.generateAsync({ type: 'blob' }).then(content => {
					const url = URL.createObjectURL(content)
					const downloadLink = document.createElement("a")
					downloadLink.href = url
					downloadLink.download = `${folderName}.zip`
					downloadLink.click()
				})
			}
		}
		catch(e) {
			console.error(e)
		}
		finally {
			printLoading.value = false
			printingReport.value = false
		}
	}

	// #region Scene Editor
	const isClient = ref(userStore.getContactType === 'Client')

	const isWeddingCategory = computed(() => {
		if(job.value?.fieldData?.zctCategoryEnglish === 'Wedding') return true
		return false
	})

	const canAccessSceneEditor = computed(() => {
		return Boolean(userStore?.user?.canAccessSceneEditor)
	})

	const canAccessServiceSequenceOrderReport = computed(() => {
		return Boolean(userStore?.user?.canAccessServiceSequenceOrderReport)
	})

	const canAccessSongExport = computed(() => {
		return Boolean(userStore?.user?.canAccessSongExport)
	})

	const scenesAreEditable = computed(() => {
		const currentDate = new Date()
		let cutoffDate = new Date(job.value?.fieldData?.date_start)
		// Get num days for cutoff from FM
		const numDays = job.value?.fieldData['jobs__PREFERENCES__cart::memberSiteEditScenesNumDaysBeforeJob']
		cutoffDate.setDate(cutoffDate.getDate() - numDays)
		const hasHadSongsSubmitted = Boolean(job.value?.fieldData?.hasHadSongsSubmitted ?? 0)

		// If songs have already been submitted do not allow edits
		if(hasHadSongsSubmitted) return false
		// If current date is after cutoff date do not allow edits
		if(currentDate > cutoffDate) return false
		return true
	})

	const sceneEditorOpen = ref<{open: boolean}>({open: false})

	function openSceneEditor() {
		sceneEditorOpen.value.open = true
	}

	function closeSceneEditor(command: string, notification?: Notification) {
		sceneEditorOpen.value.open = false

		// Reset store
		sceneEditorStore.sceneEditor.scenes = job.value?.portalData?.portal_main_scenes

		if(command === 'save') {
			displayNotification(notification)
			getData(true)
		}
	}
	// #endregion

	// #region Notification
	const showNotification = ref(false)
	const notificationIcon = ref(0)
	const notificationTitle = ref('')
	const notificationSubtitle = ref('')
	
	function displayNotification(notification: Notification) {
		notificationIcon.value = notification.icon
		notificationTitle.value = notification.title
		notificationSubtitle.value = notification.subtitle
		showNotification.value = true
	}
	// #endregion


return (_ctx: any,_cache: any) => {
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_tw_breadcrumb = _resolveComponent("tw-breadcrumb")!
  const _component_collapsable_card = _resolveComponent("collapsable-card")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_PencilIconMini = _resolveComponent("PencilIconMini")!
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (printLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_tw_loading),
          (printLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (printingReport.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("job.creatingReport")), 1))
                  : (exportingSongs.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("job.exportingSongs")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)("job.creatingInstructions")), 1))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_tw_breadcrumb, { crumbs: breadcrumb.value }, null, 8, ["crumbs"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
          [_vShow, loading.value]
        ]),
        _withDirectives(_createElementVNode("h1", {
          class: _normalizeClass(["page-title", {'text-indigo-500' : job.value?.fieldData?.['job__JOBS__kfJobsID::_kp_jobs_id']}])
        }, _toDisplayString(job.value?.fieldData?.name_bride_groom_display), 3), [
          [_vShow, !loading.value]
        ]),
        _createElementVNode("div", _hoisted_9, [
          (canAccessSongExport.value && isWeddingCategory.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (exportSceneSongs())),
                class: "flex justify-end gap-2 items-center linked-icon cursor-pointer"
              }, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_unref(t)("job.exportSongs")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (printInstructions())),
                class: "flex justify-end gap-2 items-center linked-icon cursor-pointer"
              }, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_unref(t)("job.printInstructions")), 1)
              ]))
            : _createCommentVNode("", true),
          (canAccessServiceSequenceOrderReport.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (printServiceSequenceOrderReport())),
                class: "flex justify-end gap-2 items-center linked-icon cursor-pointer"
              }, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_unref(t)("job.printServiceSequenceOrderReport")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass([_unref(userStore).getContactType === 'Staff' || job.value.fieldData?.zcnIsParty ? 'col-span-2' : 'col-span-2 lg:col-span-1'])
        }, [
          _createVNode(_component_collapsable_card, {
            title: _unref(t)('job.jobDetails')
          }, {
            default: _withCtx(() => [
              _createVNode(JobDetailsLocation, {
                job: job.value,
                loading: loading.value
              }, null, 8, ["job", "loading"])
            ]),
            _: 1
          }, 8, ["title"])
        ], 2),
        (_unref(userStore).getContactType != 'Staff' && !job.value.fieldData?.zcnIsParty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('278')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobCovidRestrictions, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('185')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobTransportationDetails, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('427')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobMeetingPlaces, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('218')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobLocations, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('187')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobItems, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_collapsable_card, {
            title: _unref(t)('job.additionalDetails')
          }, {
            default: _withCtx(() => [
              _createVNode(JobAdditionalDetails, {
                job: job.value,
                loading: loading.value
              }, null, 8, ["job", "loading"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        (_unref(userStore).getContactType != 'Staff')
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: _normalizeClass([job.value.fieldData?.zcnIsParty ? 'col-span-2' : 'col-span-2 lg:col-span-1'])
            }, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('153')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobDiscounts, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ], 2))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('205')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_data_display, {
                      loading: loading.value,
                      value: job.value?.fieldData?.['job__JOBS_INFO__jobID::notes_jobs_staff_display'] || '—'
                    }, null, 8, ["loading", "value"])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (!job.value.fieldData?.zcnIsParty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('347')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobIntroductions, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('156')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobParticipants, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType != 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('187')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobItems, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('175')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobOptions, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_collapsable_card, {
            title: _unref(_localesStore).getLabel('179')
          }, {
            default: _withCtx(() => [
              _createVNode(JobRoles, {
                job: job.value,
                loading: loading.value
              }, null, 8, ["job", "loading"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        (_unref(userStore).getContactType != 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('156')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobParticipants, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(userStore).getContactType != 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('175')
              }, {
                default: _withCtx(() => [
                  _createVNode(JobOptions, {
                    job: job.value,
                    loading: loading.value
                  }, null, 8, ["job", "loading"])
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_collapsable_card, {
            title: _unref(_localesStore).getLabel('394')
          }, {
            default: _withCtx(() => [
              _createVNode(JobVariations, {
                job: job.value,
                loading: loading.value
              }, null, 8, ["job", "loading"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_collapsable_card, {
            title: _unref(_localesStore).getLabel('178'),
            "no-fill": ""
          }, {
            default: _withCtx(() => [
              (isClient.value && isWeddingCategory.value && scenesAreEditable.value && canAccessSceneEditor.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: openSceneEditor,
                    class: "flex justify-end gap-2 items-center linked-icon cursor-pointer absolute -mt-10 ml-24"
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_PencilIconMini, { class: "size-4" })
                    ]),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sceneEditor.edit")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_scenes, (scene) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: scene.recordId,
                    class: "col-span-1"
                  }, [
                    _createVNode(SceneCard, {
                      "job-name": job.value?.fieldData?.name_bride_groom_display,
                      scene: scene
                    }, null, 8, ["job-name", "scene"])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_collapsable_card, {
            title: _unref(_localesStore).getLabel('219')
          }, {
            default: _withCtx(() => [
              _createVNode(JobBorrowedItems, {
                job: job.value,
                loading: loading.value
              }, null, 8, ["job", "loading"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_collapsable_card, {
            title: _unref(_localesStore).getLabel('203'),
            "no-fill": ""
          }, {
            default: _withCtx(() => [
              (isClient.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_documents_client, (document, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: i,
                        class: "w-full truncate hover:opacity-70",
                        href: document.signedUrl,
                        download: ""
                      }, [
                        (document.ext == 'jpeg' || document.ext == 'jpg' || document.ext == 'png' || document.ext == 'gif')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("img", {
                                src: document.signedUrl,
                                class: "w-full h-full object-cover rounded-md"
                              }, null, 8, _hoisted_37)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40)),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(document['job__DOCUMENTS__jobID::name_display']), 1),
                        _createElementVNode("div", _hoisted_42, " (v" + _toDisplayString(document['job__DOCUMENTS__jobID::version']) + ") ", 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(document['job__DOCUMENTS__jobID::description_display']), 1)
                      ], 8, _hoisted_35))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_documents_staff, (document, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: i,
                        class: "w-full truncate hover:opacity-70",
                        href: document.signedUrl,
                        download: ""
                      }, [
                        (document.ext == 'jpeg' || document.ext == 'jpg' || document.ext == 'png' || document.ext == 'gif')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("img", {
                                src: document.signedUrl,
                                class: "w-full h-full object-cover rounded-md"
                              }, null, 8, _hoisted_47)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50)),
                        _createElementVNode("div", _hoisted_51, _toDisplayString(document['job__DOCUMENTS__jobID::name_display']), 1),
                        _createElementVNode("div", _hoisted_52, " (v" + _toDisplayString(document['job__DOCUMENTS__jobID::version']) + ") ", 1),
                        _createElementVNode("div", _hoisted_53, _toDisplayString(document['job__DOCUMENTS__jobID::description_display']), 1)
                      ], 8, _hoisted_45))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_documents_staff_role, (document, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: i,
                        class: "w-full truncate hover:opacity-70",
                        href: document.signedUrl,
                        download: ""
                      }, [
                        (document.ext == 'jpeg' || document.ext == 'jpg' || document.ext == 'png' || document.ext == 'gif')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createElementVNode("img", {
                                src: document.signedUrl,
                                class: "w-full h-full object-cover rounded-md"
                              }, null, 8, _hoisted_56)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59)),
                        _createElementVNode("div", _hoisted_60, [
                          _createTextVNode(_toDisplayString(document['job__DOCUMENTS__gContactID::name_display']) + " ", 1),
                          _createElementVNode("span", _hoisted_61, "(v" + _toDisplayString(document['job__DOCUMENTS__gContactID::version']) + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_62, _toDisplayString(document['job__DOCUMENTS__gContactID::description_display']), 1)
                      ], 8, _hoisted_54))
                    }), 128))
                  ]))
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        (job.value?.portalData?.portal_meetings.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('412'),
                "no-fill": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_meetings, (meeting, i) => {
                    return (_openBlock(), _createBlock(Meeting, {
                      class: "first:rounded-t last:rounded-b rounded-t-none rounded-b-none",
                      key: i,
                      meeting: meeting
                    }, null, 8, ["meeting"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (job.value?.portalData?.portal_related_jobs.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createVNode(_component_collapsable_card, {
                title: _unref(_localesStore).getLabel('612'),
                "no-fill": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.portalData?.portal_related_jobs, (relatedJob, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(Job, {
                        job: relatedJob,
                        related: "",
                        "hide-line": ""
                      }, null, 8, ["job"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showNotification.value = false)),
          title: notificationTitle.value,
          subtitle: notificationSubtitle.value,
          duration: 8000,
          icon: notificationIcon.value
        }, null, 8, ["title", "subtitle", "icon"]))
      : _createCommentVNode("", true),
    _createVNode(_component_tw_modal, {
      breadcrumb: breadcrumb.value,
      "allow-independent-scrolling": "",
      "hide-close": "",
      "class-name": "!h-screen !w-screen !max-w-none !rounded-none !overflow-y-hidden",
      ref_key: "sceneEditorOpen",
      ref: sceneEditorOpen,
      title: _unref(t)('sceneEditor.modalTitle')
    }, {
      default: _withCtx(() => [
        _createVNode(SceneEditor, {
          onCloseModal: _cache[4] || (_cache[4] = (command, notification) => {closeSceneEditor(command, notification)})
        })
      ]),
      _: 1
    }, 8, ["breadcrumb", "title"])
  ], 64))
}
}

})